import type { RootState } from 'APP/Store/CreateStore'
import { createSelector } from 'APP/Redux/utils'
import { resolveServiceFeatures } from 'APP/Lib/ServiceFeatures'
import type { ServiceGroupSection } from 'APP/Store/Content/types'

export const selectLayoutState = (state: RootState) => state?.content?.layout?.data
export const selectServiceFeaturesState = (state: RootState) =>
  state?.content?.serviceFeatures?.data
export const selectCmsFeedState = (state: RootState) => state?.content?.cmsFeed
export const selectServiceGroupsState = (state: RootState) => state?.content?.serviceGroups?.data

export const selectOneServiceGroupState = (state: RootState, id: string) =>
  state?.content?.serviceGroups?.byId?.[id]

export const selectServiceFeatures = createSelector(
  [
    (state) => state?.content?.serviceFeatures?.data,
    (state) => state?.patient?.profile?.eligibleServices,
  ],
  (serviceFeatures, eligibleServices) => resolveServiceFeatures(serviceFeatures, eligibleServices)
)

export const selectExternalServiceState = (state: RootState, id: string) =>
  state?.content?.externalServices?.[id]

export const selectAllServiceGroups = createSelector([selectServiceGroupsState], (data) =>
  Object.values((data as unknown as ServiceGroupSection[]) ?? {}).flatMap(
    (section) => section?.serviceGroups ?? []
  )
)
